import React from "react";
import { CssBaseline, MuiThemeProvider } from "@material-ui/core";
import { Routes } from "./components/Navigation/Routes";
import theme from "./themes/theme";
import "./App.scss";
import { BrowserRouter } from "react-router-dom";
 
function App() {
  return (
    <BrowserRouter>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
          <Routes />
      </MuiThemeProvider>
    </BrowserRouter>
  );
}
 
export default App;
 